import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {channelsView_template} from '../components/templates/channelsView_template';
import {header} from './header';

declare var ko: any;
declare var page: any;

export class channels_view extends vnModule_knockoutJS{

    protected channelView: channelsView_template
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return 'channels_view';
    }

    buildContent(): Array<Element>{

        this.channelView = new channelsView_template('channels_view', this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle('Channel View');

        return [this.channelView.build()];
    }

    public fillPage(): void{

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.channelView.setBrand(idBrand);
        }
        this.getChannel();
    }

    protected getChannel(){

        this.channelView.activateLoading();

        const idChannel = this.getVnAppZone().getApp().params.idChannel;

        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        const usrReq_url: string = `/api/brand/${idBrand}/channels/get/${idChannel}`;

        let usrReq_params: Array<Array<string>> = [];

        let vm = this.channelView.getViewModelForRequest();

        usrReq_params.push(['data', ko.toJSON(vm)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetChannelRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetChannelRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.channelView.setChannel(responseParsed);
            });

            obj.channelView.deactivateLoading();
        }
    }

    protected edit(id){
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect(`/brand/${idBrand}/categorization/channels/edit/${id}`);
    }

    protected cancel() {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect(`/brand/${idBrand}/categorization/channels/`);
    }

    protected showArticle(article) {
        if(article && article.id){
            const idBrand = this.getVnAppZone().getApp().params.idBrand;
            window.open(`/brand/${idBrand}/articles/view/${article.id}`, '_blank');
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/channels_view.ts